import type { ReactNode } from "react";

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
  eyebrow?: string;
}

export default function SectionHeader({ title, subtitle, action, eyebrow }: SectionHeaderProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 md:gap-4 mb-6 md:mb-8">
      <div>
        {eyebrow && (
          <div className="flex items-center gap-2 mb-2">
            <span className="w-6 h-[2px] bg-accent-500 inline-block" />
            <span className="font-label tracking-[0.2em] text-xs uppercase text-accent-400">{eyebrow}</span>
          </div>
        )}
        <h2 className="font-heading text-2xl md:text-3xl font-semibold tracking-wide text-foreground-950">{title}</h2>
        {subtitle && <p className="mt-2 text-sm md:text-[15px] text-foreground-500 max-w-2xl">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}